import React, { useState } from "react";
import { v4 as uuid } from "uuid";

export function Student() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [age, setAge] = useState("");
  const [gendre, setGendre] = useState("M");
  const [guardianName, setGuardianName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [cellphone, setCellphone] = useState("");
  const [address, setAddress] = useState("");
  const [country, setCountry] = useState("Brasil");
  const [state, setState] = useState("Bahia");
  const [zip, setZip] = useState("");

  const [child, setChild] = React.useState([]);

  // useEffect(() => {
  //   fetch("http://localhost:5000/getChildList/", {
  //     method: "get",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Accept: "application/json",
  //     },
  //   })
  //     .then((response) => response.json())
  //     .then((data) => setChild(data))
  //     .catch((err) => console.log(`ERROR: ${err}`));
  // }, []);

  const handleSubmit = (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    formData.append("id", uuid());
    const formDataObject = Object.fromEntries(formData.entries());

    let childs = localStorage.getItem("CHILDS") || "";
    childs = childs.concat(JSON.stringify(formDataObject), ", ");
    localStorage.setItem("CHILDS", childs);

    alert("Criança cadastrada com sucesso!");
    handleReset();
  };

  const handleReset = () => {
    setFirstName("");
    setLastName("");
    setAge("");
    setGendre("");
    setGuardianName("");
    setEmail("");
    setPhone("");
    setCellphone("");
    setAddress("");
    setCountry("");
    setState("");
    setZip("");
  };

  return (
    <div className="container my-3 py-5">
      <main className="mt-5">
        <h3 className="fw-light pb-2">
          <i className="bi bi-person-vcard"></i> Cadastrar Aluno
        </h3>

        <form onSubmit={handleSubmit}>
          <div className="row g-3">
            <div className="col-sm-5">
              <label htmlFor="firstName" className="form-label">
                Nome
              </label>
              <input
                type="text"
                className="form-control"
                id="firstName"
                name="firstName"
                placeholder=""
                value={firstName}
                onChange={(event) => setFirstName(event.target.value)}
                required
              />
              <div className="invalid-feedback">Nome é obrigatório.</div>
            </div>

            <div className="col-sm-5">
              <label htmlFor="lastName" className="form-label">
                Sobrenome
              </label>
              <input
                type="text"
                className="form-control"
                id="lastName"
                name="lastName"
                value={lastName}
                onChange={(event) => setLastName(event.target.value)}
                required
              />
              <div className="invalid-feedback">Sobrenome é obrigatório.</div>
            </div>

            <div className="col-sm-1">
              <label htmlFor="age" className="form-label">
                Idade
              </label>
              <input
                type="number"
                className="form-control"
                id="age"
                name="age"
                value={age}
                onChange={(event) => setAge(event.target.value)}
                required
              />
              <div className="invalid-feedback">Idade é obrigatório.</div>
            </div>

            <div className="col-md-1">
              <label htmlFor="gendre" className="form-label">
                Sexo
              </label>
              <select
                className="form-select"
                id="gendre"
                name="gendre"
                value={gendre}
                onChange={(event) => setGendre(event.target.value)}
                required
              >
                <option value="">Escolher...</option>
                <option>M</option>
                <option>F</option>
              </select>
              <div className="invalid-feedback">Sexo é obrigatório.</div>
            </div>
            <div className="col-12">
              <label htmlFor="address" className="form-label">
                Endereço
              </label>
              <input
                type="text"
                className="form-control"
                id="address"
                name="address"
                value={address}
                onChange={(event) => setAddress(event.target.value)}
                required
              />
              <div className="invalid-feedback">Endereço é obrigatório.</div>
            </div>

            <div className="col-md-5">
              <label htmlFor="country" className="form-label">
                País
              </label>
              <select
                className="form-select"
                id="country"
                name="country"
                value={country}
                onChange={(event) => setCountry(event.target.value)}
                required
              >
                <option value="">Escolher...</option>
                <option>Brasil</option>
              </select>
              <div className="invalid-feedback">País é obrigatório.</div>
            </div>

            <div className="col-md-4">
              <label htmlFor="state" className="form-label">
                Estado
              </label>
              <select
                className="form-select"
                id="state"
                name="state"
                value={state}
                onChange={(event) => setState(event.target.value)}
                required
              >
                <option value="">Escolher...</option>
                <option>Bahia</option>
              </select>
              <div className="invalid-feedback">Estado é obrigatório.</div>
            </div>

            <div className="col-md-3">
              <label htmlFor="zip" className="form-label">
                Código Postal
              </label>
              <input
                type="text"
                className="form-control"
                id="zip"
                name="zip"
                placeholder=""
                value={zip}
                onChange={(event) => setZip(event.target.value)}
                required
              />
              <div className="invalid-feedback">
                Código Postal é obrigatório.
              </div>
            </div>
            <div className="col-sm-12">
              <label htmlFor="guardianName" className="form-label">
                Responsável
              </label>
              <div className="input-group has-validation">
                <span className="input-group-text"></span>
                <input
                  type="text"
                  className="form-control"
                  id="guardianName"
                  name="guardianName"
                  placeholder="Nome Completo"
                  value={guardianName}
                  onChange={(event) => setGuardianName(event.target.value)}
                  required
                />
                <div className="invalid-feedback">
                  Nome do responsável é obrigatório.
                </div>
              </div>
            </div>

            <div className="col-12">
              <label htmlFor="email" className="form-label">
                Email do Responsável
              </label>
              <div className="input-group has-validation">
                <span className="input-group-text"></span>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  placeholder="abc@gmail.com"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  required
                />
                <div className="invalid-feedback">Email é obrigatório.</div>
              </div>
            </div>

            <div className="col-md-6">
              <label htmlFor="phone" className="form-label">
                Telefone do Responsável
              </label>
              <div className="input-group has-validation">
                <span className="input-group-text"></span>
                <input
                  type="tel"
                  className="form-control"
                  id="phone"
                  name="phone"
                  value={phone}
                  onChange={(event) => setPhone(event.target.value)}
                  required
                ></input>
                <div className="invalid-feedback">Telefone é obrigatório.</div>
              </div>
            </div>

            <div className="col-md-6">
              <label htmlFor="cellphone" className="form-label">
                Celular do Responsável
              </label>
              <div className="input-group has-validation">
                <span className="input-group-text"></span>
                <input
                  type="tel"
                  className="form-control"
                  id="cellphone"
                  name="cellphone"
                  value={cellphone}
                  onChange={(event) => setCellphone(event.target.value)}
                  required
                />
                <div className="invalid-feedback">Celular é obrigatório.</div>
              </div>
            </div>

            <hr className="my-4"></hr>

            <button className="w-100 btn btn-primary btn-lg" type="submit">
              Salvar
            </button>
          </div>
        </form>
      </main>
    </div>
  );
}
